export default __webpack_public_path__ + "static/media/minus-icon.dc9d63d7.svg";